module.exports = __webpack_public_path__ + "website/img/imgo_bot.58c56510.png";